import { SvgIcon } from '@progress/kendo-react-common';
import React from 'react';
import { CheckmarkOutline } from '../../../icons/icons';
import { WorkerThresholdLevel } from '../../../monitoring/models';
import { DECIMAL_THRESHOLD_DIVISOR, ThresholdControlType, ThresholdInfo } from '../../../types/thresholds';

export function BreachedThresholdValueCell({ info, level }: { info: ThresholdInfo; level: WorkerThresholdLevel | null }): React.ReactNode {
    if (!level) {
        return '-';
    }

    if (info.controlType === ThresholdControlType.checkbox) {
        return <SvgIcon icon={CheckmarkOutline} />;
    }

    if (info.controlType === ThresholdControlType.dropdown) {
        return info.dropdownOptions![level.rawValue] ?? '-';
    }

    if (info.controlType === ThresholdControlType.input) {
        let value = level.rawValue;

        if (info.decimal) {
            value /= DECIMAL_THRESHOLD_DIVISOR;
        }

        if (level.unitIndex !== null) {
            value /= info.customUnits[level.unitIndex].multiplier;
        }

        return (
            <span>
                {info.decimal ? value.toFixed(2) : value.toString()}
                {level.unitIndex !== null
                    ? info.customUnits[level.unitIndex].displayName
                    : // Some thresholds level have unitIndex=null while they should be using custom units
                      // in that case try to grab first unit from the list and if there's none then use info.units string field
                      (info.customUnits[0]?.displayName ?? info.units)}
            </span>
        );
    }

    throw new Error('Unknown threshold control type');
}
